import { render, staticRenderFns } from "./SLPayment.vue?vue&type=template&id=39ada53c&"
import script from "./SLPayment.vue?vue&type=script&lang=js&"
export * from "./SLPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports